import { render, staticRenderFns } from "./commission-tabbar.vue?vue&type=template&id=ae2114d8&scoped=true&"
import script from "./commission-tabbar.vue?vue&type=script&lang=ts&"
export * from "./commission-tabbar.vue?vue&type=script&lang=ts&"
import style0 from "./commission-tabbar.vue?vue&type=style&index=0&id=ae2114d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2114d8",
  null
  
)

export default component.exports